import { RoleName } from '@marageti/z4-sdk/lib/auth';
import { UserInfo } from '@marageti/z4-sdk/lib/people';

export const authorizedRoles: RoleName[] = [
  RoleName.ADMIN,
  RoleName.PARTNERSHIPS,
  RoleName.CARE,
];

export const getMatchingUser = (email: string, userInfo: UserInfo[]): UserInfo | undefined => (
  userInfo.find((user: UserInfo) => user.email === email)
);
